import { render } from "./CommonFooter.vue?vue&type=template&id=7cad7b82&scoped=true"
import script from "./CommonFooter.vue?vue&type=script&lang=js"
export * from "./CommonFooter.vue?vue&type=script&lang=js"

import "./CommonFooter.vue?vue&type=style&index=0&id=7cad7b82&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7cad7b82"]])

export default __exports__